import { Urls } from "./urls";

export const getCurrentPath = (): string => window.location.pathname;

export const routing = {
  getCurrentPath,
  Urls
};
